import { useMutation } from "@tanstack/react-query";
import {
  PatientProcedureCode,
  PatientProcedureCodeControllerApi,
} from "../../services";
import { getConfigObject, getXtenantId } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

/**
 * The sub-total is recalculated while the user is still typing, so the money
 * and quantity fields are the raw input strings at that point. They are posted
 * verbatim and parsed by the backend, so the request body is the generated
 * model widened to allow those in-progress values.
 */
export interface SubTotalProcedureCodePayload extends Omit<
  PatientProcedureCode,
  "charges" | "quantity" | "discount"
> {
  charges?: number | string | null;
  quantity?: number | string | null;
  discount?: number | string | null;
}

export interface GetSubTotalForPatientProcedureCodeProps {
  patientProcedureCode: SubTotalProcedureCodePayload;
  renderingProviderUuid?: string;
}

export const useCheckSubTotalForPatientProcedureCode = () =>
  useMutation({
    mutationFn: async ({
      patientProcedureCode,
      renderingProviderUuid,
    }: GetSubTotalForPatientProcedureCodeProps) =>
      new PatientProcedureCodeControllerApi(
        getConfigObject()
      ).getSubTotalForPatientProcedureCode(
        // Narrowing back to the generated model at the SDK boundary: the widened
        // string values above are what the endpoint is intentionally sent.
        patientProcedureCode as PatientProcedureCode,
        renderingProviderUuid,
        getXtenantId()
      ),
  });
